import { useEffect, useState } from "react";
import API from "../services/api";

const AdminWithdrawDashboard = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  // =========================
  // FETCH WITHDRAWALS
  // =========================
  const fetchWithdrawals = async () => {
    try {
      const res = await API.get("/admin/withdraw/");
      setWithdrawals(res.data);
    } catch (err) {
      console.error("Failed to load withdrawals:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  // =========================
  // APPROVE
  // =========================
  const approve = async (id) => {
    try {
      await API.post(`/admin/withdraw/approve/${id}`);
      fetchWithdrawals();
    } catch (err) {
      alert("Approve failed");
      console.error(err);
    }
  };

  // =========================
  // REJECT
  // =========================
  const reject = async (id) => {
    try {
      await API.post(`/admin/withdraw/reject/${id}`);
      fetchWithdrawals();
    } catch (err) {
      alert("Reject failed");
      console.error(err);
    }
  };

  // =========================
  // LOADING
  // =========================
  if (loading) return <h2>Loading withdrawals... ⏳</h2>;

  return (
    <div style={{ maxWidth: 900, margin: "auto", padding: 20 }}>
      <h1>🧑‍💼 Admin Withdraw Dashboard</h1>

      <p style={{ opacity: 0.6 }}>
        Manage creator payout requests
      </p>

      {/* TABLE */}
      <div style={{ marginTop: 20 }}>
        {withdrawals.length === 0 ? (
          <p>No withdrawal requests</p>
        ) : (
          withdrawals.map((w) => (
            <div
              key={w.id}
              style={{
                border: "1px solid #eee",
                padding: 15,
                borderRadius: 10,
                marginBottom: 10,
              }}
            >
              {/* TOP ROW */}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <h3>₦{w.amount}</h3>
                  <p style={{ fontSize: 12, opacity: 0.7 }}>
                    User ID: {w.user_id}
                  </p>
                </div>

                <span
                  style={{
                    padding: "5px 10px",
                    borderRadius: 6,
                    background:
                      w.status === "pending"
                        ? "#fef3c7"
                        : w.status === "approved"
                        ? "#d1fae5"
                        : "#fee2e2",
                  }}
                >
                  {w.status}
                </span>
              </div>

              {/* BANK INFO */}
              <div style={{ marginTop: 10, fontSize: 14 }}>
                <p>🏦 {w.bank_name}</p>
                <p>🔢 {w.account_number}</p>
                <p>👤 {w.account_name}</p>
              </div>

              {/* ACTIONS */}
              {w.status === "pending" && (
                <div
                  style={{
                    marginTop: 10,
                    display: "flex",
                    gap: 10,
                  }}
                >
                  <button
                    onClick={() => approve(w.id)}
                    style={{
                      padding: "8px 12px",
                      background: "green",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      cursor: "pointer",
                    }}
                  >
                    Approve
                  </button>

                  <button
                    onClick={() => reject(w.id)}
                    style={{
                      padding: "8px 12px",
                      background: "red",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      cursor: "pointer",
                    }}
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminWithdrawDashboard;